import { render } from "./BackendLogs.vue?vue&type=template&id=6677a151&scoped=true"
import script from "./BackendLogs.vue?vue&type=script&lang=js"
export * from "./BackendLogs.vue?vue&type=script&lang=js"

import "./BackendLogs.vue?vue&type=style&index=0&id=6677a151&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6677a151"]])

export default __exports__